export const getVerifyContinueErrorMessage = (
  error: any,
  fallback = 'error creating a new account'
): string => {
  if (error?.response?.data?.message) {
    return error.response.data.message
  }

  const message = error?.message
  if (message === 'promise timeout') {
    return 'Sign-in timed out. Please wait a moment and try signing in.'
  }
  if (error?.code === 'UserNotConfirmedException') {
    return 'Your account is still being set up. Please try again in a few seconds.'
  }
  if (error?.code === 'NotAuthorizedException') {
    return 'Unable to sign in. Please check your password and try again.'
  }
  if (message) {
    return message
  }

  return fallback
}

export const getOtpVerificationErrorMessage = (
  responseMessage: string | undefined,
  fallback = 'Invalid or expired code. Please try again.'
): string => {
  if (!responseMessage) {
    return fallback
  }
  if (responseMessage === 'Unable to verify email in Cognito') {
    return 'Unable to verify your email. Please try again.'
  }
  return responseMessage
}
